import "./conditional-form-group.css";
import { Vue, Component, Prop } from "vue-property-decorator";
import {forEach} from "lodash-es";

@Component
class ConditionalFormGroup extends Vue {
    @Prop({type: String, default: ""})
    public conditionalFieldId: string;

    @Prop({type: String, default: ""})
    public conditionalFieldValue: string;

    isHidden = true;
    requiredFields: NodeListOf<HTMLFormElement>;

    public mounted() {
        if (this.conditionalFieldId) {
            this.requiredFields = this.$el.querySelectorAll("[required]");
            this.handleRequiredFields();

            const field = document.querySelector("#" + this.conditionalFieldId) as HTMLFormElement;
            if (field) {
                field.addEventListener('change', () => {
                    this.isHidden = field.value !== this.conditionalFieldValue;
                    this.handleRequiredFields();
                });
            }
        }

    }

    private handleRequiredFields() {
        if (this.isHidden) {
            forEach(this.requiredFields, (field) => {
                field.removeAttribute("required");
                field.value = 0;
            });
        } else {
            forEach(this.requiredFields, (field) => {
                field.setAttribute("required", "true");
                field.value = "";
            });
        }
    }

}

export default ConditionalFormGroup;



// WEBPACK FOOTER //
// ./src/components/conditional-form-group.ts